"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("../../control-components/ui-components/Button"));

var Confirmation = function Confirmation(_ref) {
  var phrases = _ref.phrases;
  return (0, _preact.h)("div", {
    className: "unsubscribe-wrapper"
  }, (0, _preact.h)("div", {
    className: "unsubscribe-title"
  }, phrases.title), (0, _preact.h)("div", {
    className: "unsubscribe-body"
  }, phrases.body), (0, _preact.h)("div", {
    className: "unsubscribe-action"
  }, (0, _preact.h)("form", {
    method: "POST"
  }, (0, _preact.h)(_Button.default, {
    primary: true,
    type: "submit",
    title: phrases.button
  }))));
};

var _default = Confirmation;
exports.default = _default;